export default "https://cdn-static.gokick.com/assets/6600ddf3ffcd3e3653ecf6807c0977bcbaa0931f/images/sleep-tangerine.755ecdb6db700f77bb8084d276871abe.png";